// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import { discontinuedProductListLineStyles } from "@werner/Overrides/Widgets/MyListsDetails/MyListDetailsDiscontinuedProductListLine";
import Trash from "@werner/XDL/Icons/Trash";
import { color, iconLinkCommonStyles, xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

discontinuedProductListLineStyles.deleteLink = {
    ...iconLinkCommonStyles(Trash),
};

discontinuedProductListLineStyles.emptySpaceWrapper = {
    css: css`
        width: 100px;
        height: 100px;
        ${xScreen("lte", "sm")} {
            width: 280px;
            height: 280px;
        }
    `,
};

discontinuedProductListLineStyles.selectedCheckbox = {
    css: css`
        span[role="checkbox"] {
            display: none !important;
        }

        transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;

        label {
            margin-left: 0 !important;
            font-size: 14px;
            font-weight: 500;
            color: ${color("primary")};
            letter-spacing: 0;
            line-height: 15px;
            display: flex;
            align-items: center;
            cursor: pointer;

            ${IconWrapper} {
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
                display: flex;
                align-items: center;
                margin-right: 4px;
                color: ${color("primary")};
            }
        }

        ${({ checked }: any) =>
            checked &&
            css`
                label,
                label ${IconWrapper} {
                    color: ${color("danger")};
                }
            `}

        &:hover {
            label,
            ${IconWrapper} {
                color: ${color("common.ui1")};
                opacity: 1;
            }
        }
    `,
};

discontinuedProductListLineStyles.actions = {
    css: css`
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        @media print {
            display: none;
        }
        ${xScreen("lte", "sm")} {
            flex-direction: column-reverse;
        }
    `,
};

discontinuedProductListLineStyles.discontinuedLineContainer = {
    css: css`
        margin: 0 auto;
        height: 100%;
        width: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding: 12px;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            max-width: 280px;
        }
        @media print {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            width: 100%;
            max-width: 100%;
        }
    `,
};

discontinuedProductListLineStyles.info = {
    css: css`
        max-width: 510px;
        flex: 1 1 auto;
        margin-right: auto;
        ${xScreen("lte", "md")} {
            max-width: 365px;
        }

        ${xScreen("lte", "sm")} {
            max-width: 510px;
        }
    `,
};

discontinuedProductListLineStyles.imageSection = {
    css: css`
        margin-right: 12px;
        background-color: ${color("common.white")};
        ${xScreen("lte", "sm")} {
            margin: 0 auto 12px;
        }
        @media print {
            margin-right: 12px;
        }
    `,
};

discontinuedProductListLineStyles.innerGridContainer = {
    gap: 10,
    css: css`
        width: 100%;
    `,
};

discontinuedProductListLineStyles.discontinuedDescriptionGridItem = {
    width: 12,
    printWidth: 6,
    css: css`
        flex-direction: column;
    `,
};

discontinuedProductListLineStyles.restrictedDescriptionText = {
    css: css`
        font-weight: 500;
    `,
};
